<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <GeneralCustomizations />
    <div class="full-width">
      <div class="text-right mb-2">
        <a :href="customerPortalURL" target="_blank">
          <i class="far fa-calendar-plus mr-1"></i>
          View Live Widget</a
        >
      </div>
      <div
        class="full-width elevation-1"
        style="border-radius: 5px; overflow: hidden"
      >
        <BrowserHead
          :get-value="getValue"
          tab-name="Widget"
          :url="getValue('homepage_url')"
        />
        <div class="widget-preview">
          <h5 :style="`color: ${getValue('secondary_color')}`">Schedule</h5>
          <hr />
          <div class="widget-form-section mb-4" :style="getBorder()">
            <div class="widget-input"></div>
          </div>
          <div class="widget-form-section mb-4" :style="getBorder()">
            <div class="widget-input"></div>
            <div class="widget-input"></div>
          </div>
          <div class="widget-form-section mb-4" :style="getBorder()">
            <div class="widget-input"></div>
            <div class="widget-input"></div>
            <div class="widget-input"></div>
            <div class="widget-input"></div>
          </div>
          <div
            class="widget-btn"
            :style="`color: #FFF; background-color: ${getValue(
              'primary_color'
            )}`"
          >
            Schedule Appointment
          </div>
        </div>
      </div>
      <div
        class="full-width elevation-1 mt-4"
        style="border-radius: 5px; overflow: hidden"
      >
        <BrowserHead
          :get-value="getValue"
          tab-name="Widget"
          :url="getValue('homepage_url')"
        />
        <div class="widget-preview">
          <h5 :style="`color: ${getValue('secondary_color')}`">Confirmation</h5>
          <hr />
          <div class="d-flex mb-4 widget-confirm-header">
            <div class="widget-form-section px-0 py-0">
              <div
                class="header-bar"
                :style="`color: #FFF; background-color: ${getValue(
                  'secondary_color'
                )}`"
              >
                <div class="skeleton-bar white"></div>
              </div>

              <div class="px-4 py-4">
                <div class="skeleton-bar"></div>
                <div class="skeleton-bar"></div>
              </div>
            </div>
            <div class="widget-form-section px-0 py-0 ml-2">
              <div
                class="header-bar"
                :style="`color: #FFF; background-color: ${getValue(
                  'secondary_color'
                )}`"
              >
                <div class="skeleton-bar white"></div>
              </div>
              <div style="position: relative" class="d-flex">
                <div
                  class="flex-1 px-4 py-4"
                  style="width: 250px; position: absolute; left: 0; top: 0"
                >
                  <div class="skeleton-bar"></div>
                  <div class="skeleton-bar"></div>
                </div>
                <div class="widget-clock">
                  <Clock :get-value="getValue" />
                </div>
              </div>
            </div>
          </div>
          <div
            class="widget-form-section d-flex flex-column px-0 py-0"
            style="height: 300px"
          >
            <div
              class="header-bar full-width"
              :style="`color: #FFF; background-color: ${getValue(
                'secondary_color'
              )}`"
            >
              <div class="skeleton-bar white"></div>
            </div>
            <div class="d-flex flex-1">
              <div style="flex: 1; flex-grow: 2">
                <div class="px-4 py-4">
                  <div class="skeleton-bar"></div>
                  <div class="skeleton-bar"></div>
                  <div class="skeleton-bar"></div>
                  <div class="skeleton-bar"></div>
                </div>
                <div class="px-4">
                  <div class="skeleton-bar"></div>
                  <div class="skeleton-bar"></div>
                </div>
              </div>
              <div style="flex: 1; background: #ededed" class="px-4">
                <div class="widget-input mt-4"></div>
                <div
                  class="widget-btn full-width"
                  :style="`color: ${getValue(
                    'secondary_color'
                  )}; border: 1px solid ${getValue(
                    'secondary_color'
                  )}; background-color: #fafeff`"
                >
                  Button
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

import BrowserHead from "../BrowserHead.vue";
import Clock from "../Clock.vue";
import GeneralCustomizations from "../GeneralCustomizations.vue";
import { injectUseTenantCustomization } from "../useTenantCustomization";

const { getValue } = injectUseTenantCustomization();
const customerPortalURL = ref("");

onMounted(() => {
  const cpURL = $("#hidden_tenant_customer_portal_url").val();
  customerPortalURL.value = `${cpURL}/schedule-appointment`;
});

function getBorder() {
  return `box-shadow: 0 2px 8px rgba(102,102,102,0.08), 0 10px 0 -5px ${getValue(
    "secondary_color"
  )} inset`;
}
</script>

<style lang="scss" scoped>
.two-columns {
  display: grid;
  grid-template-columns: calc(50% - 18px) calc(50% - 18px);
  gap: 36px;
}
.widget-preview {
  width: 100%;
  background: #fff;
  padding: 30px 60px;
  .widget-form-section {
    background: #fafeff;
    border: 1px solid #e4e4e4;
    border-radius: 10px;
    padding: 1em;
    box-shadow: 0 2px 8px rgba(102, 102, 102, 0.08);
    .widget-input {
      display: block;
      width: 100%;
      padding: 15px 25px !important;
      font-size: 1em;
      line-height: 1.5;
      background-color: #fff;
      border: 1px solid #e4e4e4;
      border-radius: 10px;
      outline: none;
      margin: 0;
      box-sizing: border-box;
      box-shadow: none;
      height: 30px;
      margin-bottom: 15px;
    }
  }
  .widget-btn {
    border-radius: 50px;
    height: 35px;
    width: 245px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h2 {
    color: #017e9c;
  }
  .widget-confirm-header {
    .widget-form-section {
      flex: 1;
      height: 160px;
      &:nth-child(2) {
        flex-grow: 2;
      }
    }
  }
  .header-bar {
    height: 35px;
    border-radius: 10px 10px 0 0;
    padding: 5px 15px;
  }
}
</style>
